<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 48上传
  -->
  <gaia-upload
    ref="upload"
    v-model="form"
    types="gaia48"
    :formatList="formatList"
  >
    <div v-show="settingVisible && modalVisible">
      <div class="title" style="font-size: 14px">基本信息</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        status-icon
        label-position="top"
        size="mini"
      >
        <el-checkbox
          v-model="sameTitle"
          style="float: right"
          @change="changeTitle"
        >
          <span>统一标题</span>
          <question-prompt
            content="勾选此项并“应用到全部”时，所有视频使用同一标题，标题名称按添加顺序增加数字编号。"
          />
        </el-checkbox>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="基础信息" prop="info">
          <div class="input-group">
            <el-input
              v-model="form.number"
              placeholder="剧组编号"
              style="width: 31%"
            />
            <el-input
              v-model="form.director"
              placeholder="导演"
              style="width: 31%"
            />
            <el-select
              v-model="form.year"
              placeholder="年份"
              style="width: 31%"
            >
              <el-option label="2019" value="2019"> </el-option>
              <el-option label="2020" value="2020"> </el-option>
              <el-option label="2021" value="2021"> </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="所属地区" prop="areaId">
          <el-select
            v-model="form.areaId"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, i) in addressList"
              :key="i"
              :label="`${item.text} | ${item.pinyin} | ${item.startTime} - ${item.endTime}`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创作人" prop="tags">
          <el-input
            v-model="peoples"
            :readonly="true"
            @focus="tagSelectVisible = true"
          ></el-input>
          <gaia48-people
            v-model="tagSelectVisible"
            :creatorList="form.creatorList"
            @change="
              (creatorList) => {
                form.creatorList = creatorList;
                peoples = JSON.stringify(creatorList);
              }
            "
          />
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="封面（506px*960）" prop="pass">
          <upload-cover width="78px" :src="form.cover" @change="coverChange" />
        </el-form-item>
        <el-form-item>
          <div class="info-box">
            <div class="item">
              <div class="name">短片介绍</div>
              <div class="box" @click="openEditDetail(0)">
                <i class="el-icon-plus"></i>
                <span>{{ !form.detail ? "编辑介绍" : "重新编辑" }}</span>
              </div>
            </div>
            <div class="item">
              <div class="name">缘起</div>
              <div class="box" @click="openEditDetail(1)">
                <i class="el-icon-plus"></i>
                <span>{{ !form.story ? "编辑缘起" : "重新编辑" }}</span>
              </div>
            </div>
            <div class="item">
              <div class="name">剧本分镜</div>
              <div class="box" @click="openEditDetail(2)">
                <i class="el-icon-plus"></i>
                <span>{{ !form.storyBoard ? "编辑分镜" : "重新编辑" }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="!access"
            :loading="applyLoading"
            type="primary"
            @click="upload"
            style="width: 74%"
          >
            应用
          </el-button>
          <el-button
            :disabled="!access"
            plain
            @click="submit"
            style="width: 23.9%"
            type="primary"
          >
            应用到全部
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="access"> 上传即表示您已同意网站 </el-checkbox>
          <a
            class="pact"
            href="https://gaiamount.com/desktop/richPage?type=2"
            target="_blank"
          >
            《上传协议》
          </a>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="editDetailVisible">
      <div v-if="editIndex === 0" class="title" style="font-size: 14px">
        短片介绍
      </div>
      <div v-if="editIndex === 1" class="title" style="font-size: 14px">
        缘起
      </div>
      <div v-if="editIndex === 2" class="title" style="font-size: 14px">
        剧本分镜
      </div>
      <gaia-editor v-model="story" />
      <div style="margin-top: 20px">
        <el-button
          type="primary"
          size="mini"
          style="width: 74%"
          @click="editDetailSave(true)"
        >
          保存
        </el-button>
        <el-button
          size="mini"
          plain
          style="width: 23.9%"
          @click="editDetailSave(false)"
        >
          取消
        </el-button>
      </div>
    </div>
  </gaia-upload>
</template>

<script>
import gaiaUpload from "@/components/upload/gaia-upload.vue";
import UploadCover from "@/components/upload/upload-cover";
import QuestionPrompt from "@/components/question-prompt/question-prompt";
import UploadFile from "@/components/upload/upload-file";
import GaiaEditor from "@/components/gaia-editor/gaia-editor";
import { videoFormatList } from "../material/upload/format-list";
import {
  materialMusics,
  checkVerified,
  upload48Video,
  get48Addr,
} from "@/api/upload";
import { getMaterialTags, getOwnMaterialTags } from "@/api/material";
import tagSelect from "@/components/tag-select/tag-select";
import gaia48People from "@/components/gaia48-people/gaia48-people";
export default {
  components: {
    gaiaUpload,
    UploadCover,
    QuestionPrompt,
    UploadFile,
    GaiaEditor,
    tagSelect,
    gaia48People,
  },
  data() {
    const info = (rule, value, callback) => {
      if (
        this.form.number == "" ||
        this.form.director == "" ||
        this.form.year == ""
      ) {
        callback(new Error("基础信息不能为空"));
      } else {
        callback();
      }
    };
    const tags = (rule, value, callback) => {
      // if (this.form.tags.split(";").length < 2) {
      //   callback(new Error("分类标签至少选择两个"));
      // } else {
      // }
      callback();
    };
    return {
      tagSelectVisible: false,
      settingVisible: true,
      sameTitle: false, // 统一标题
      editDetailVisible: false, // 富文本编辑
      editIndex: 0,
      story: "", // 介绍
      detail: "",
      storyBoard: "",
      modalVisible: false,
      formatList: videoFormatList,
      rules: {
        title: [
          {
            required: true,
            message: "请输入素材名称",
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: "长度在 4 到 50 个字符",
            trigger: "change",
          },
        ],
        info: [{ validator: info, trigger: "change", required: true }],
        allowDownload: [{ required: true }],
        tags: [{ validator: tags, required: true }],
        areaId: [{ required: true, trigger: "change" }],
      },
      addressList: [],
      applyLoading: false,
      access: false,
      form: {
        number: "",
        director: "", // 导演
        areaId: 1,
        id: -1,
        allowDownload: false,
        title: "",
        cover: "/web/img/material-music-cover.jpg",
        tags: "",
        creatorList: [],
        detail: "", // 简介
        story: "", // 缘起
        storyBoard: "", // 剧本分镜
        year: "", // 年份
        haveSetTime: false,
        time: [],
        format: "",
        audioCodec: "COPY_OPTIMUM",
        colorEnhancement: "",
        colorPrimaries: "",
        colorRange: "",
        colorSpace: "",
        colorTransfer: "",
        crf: "23.0",
        fps: 0,
        inputGamma: "",
        inputGamut: "",
        outputGamma: "",
        outputGamut: "",
        peak: 100,
        pixelFormat: "YUV420P",
        sampleFormat: "S16",
        sts: true,
        size: 0,
        subtitleCodec: "COPY",
        toDynamicRange: "SDR",
        uploadConfiguration: true,
        videoCodec: "AVC",
      },
      peoples: "",
    };
  },
  watch: {
    form(form) {
      this.modalVisible = this.$refs.upload.fileList.length > 0;
    },
  },
  created() {
    this.form.allowDownload = Boolean(
      parseInt(this.$route.query.allowDownload)
    );
    this.get48Addr();
  },
  methods: {
    get48Addr() {
      get48Addr().then((res) => {
        this.addressList = res.areas;
        this.form.areaId = res.areas[0].id;
      });
    },
    /**
     * 统一标题
     */
    changeTitle() {
      const fileList = this.$refs.upload.fileList;
      const checked = this.$refs.upload.checked;
      const name = this.form.title;
      if (this.sameTitle) {
        fileList.map((el, i) => {
          if (i !== checked) {
            i = i + 1;
            el.form.title = `${name} (${i + (i > checked ? 0 : 1)})`;
          }
        });
      } else {
        fileList.map((el, i) => {
          el.form.title = el.name;
        });
      }
    },
    /**
     * 文件列表被清空
     */
    clearForm() {
      this.modalVisible = false;
      this.editDetailVisible = false;
    },
    /**
     * 封面改变
     */
    coverChange(cover) {
      this.form.cover = cover;
    },
    /**
     * 打开富文本编辑器 以及保存到form表单
     */
    openEditDetail(editIndex) {
      this.editIndex = editIndex;
      this.settingVisible = false;
      this.editDetailVisible = true;
      if (this.editIndex === 0) {
        this.story = this.form.detail;
      } else if (this.editIndex === 1) {
        this.story = this.form.story;
      } else if (this.editIndex === 2) {
        this.story = this.form.storyBoard;
      }
    },
    editDetailSave(bool) {
      if (bool) {
        if (this.editIndex === 0) {
          this.form.detail = this.story;
        } else if (this.editIndex === 1) {
          this.form.story = this.story;
        } else if (this.editIndex === 2) {
          this.form.storyBoard = this.story;
        }
      }
      this.story = "";
      this.settingVisible = true;
      this.editDetailVisible = false;
    },

    /**
     * 应用当前素材
     */
    upload() {
      return new Promise((resolve, reject) => {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const checked = this.$refs.upload.checked;
            if (this.$refs.upload.fileList[checked].status !== "ready") {
              this.$message.error("请勿重复点击");
              resolve();
              return;
            } else {
              let temp = JSON.parse(JSON.stringify(this.form));
              console.log("submit!");
              this.$refs.upload.upload(checked, upload48Video, temp);
              resolve();
              return;
            }
          } else {
            reject();
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    /**
     * 应用到全部
     */
    async submit() {
      const fileList = this.$refs.upload.fileList;
      for (let i = 0; i < fileList.length; i++) {
        this.$refs.upload.checked = i;
        await this.sleep(1000);
        await this.upload();
      }
    },
    sleep(time) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.input-group {
  div {
    margin: 0 0 6px 3.5%;
  }
  div:nth-child(4n + 1) {
    margin-left: 0;
  }
}
.type-btn {
  height: 40px;
  line-height: 40px;
  margin: 30px 0;
  border-radius: 4px;
  font-size: 12px;
  color: #ffffff;
  background: linear-gradient(90deg, #6464fa 0%, #4ca0ff 100%);
  text-align: center;
  user-select: none;
  cursor: pointer;
  .bold {
    font-weight: bold;
    margin-right: 10px;
  }
}
</style>
